
import { supabase } from '@/integrations/supabase/client';
import { AuthorProfile } from './types';

export const fetchUserProfile = async (userId: string) => {
  return await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();
};

export const fetchAuthorProfile = async (userId: string) => {
  return await supabase
    .from('author_profiles')
    .select('*')
    .eq('user_id', userId)
    .maybeSingle();
};

export const updateProfileToAuthor = async (userId: string) => {
  return await supabase
    .from('profiles')
    .update({ is_author: true })
    .eq('id', userId);
};

export const createAuthorProfile = async (userId: string, authorData: AuthorProfile) => {
  return await supabase
    .from('author_profiles')
    .insert([
      {
        user_id: userId,
        pen_name: authorData.penName,
        biography: authorData.biography,
        genres: authorData.genres,
        published_works: authorData.publishedWorks || 0,
        created_at: new Date().toISOString()
      }
    ]);
};

export const signInWithEmail = async (email: string, password: string) => {
  return await supabase.auth.signInWithPassword({
    email,
    password
  });
};

export const signUpWithEmail = async (email: string, password: string, userData: any) => {
  const authResponse = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        full_name: userData.fullName || '',
        username: userData.username || '',
      }
    }
  });

  if (!authResponse.error && authResponse.data.user) {
    supabase.functions.invoke('send-email', {
      body: {
        template: 'welcome',
        to: email,
        data: { name: userData.fullName || userData.username || '' },
      },
    }).catch(console.error);
  }

  return authResponse;
};

export const signOutUser = async () => {
  return await supabase.auth.signOut();
};

// New function to promote a user to admin
export const setUserAsAdmin = async (userId: string) => {
  return await supabase
    .from('profiles')
    .update({ is_admin: true })
    .eq('id', userId);
};
